// Comprehensive list of high school and college sports
export const SPORTS_LIST = [
  // Ball Sports
  { value: 'Basketball', label: 'Basketball', category: 'Ball Sports' },
  { value: 'Football', label: 'Football', category: 'Ball Sports' },
  { value: 'Soccer', label: 'Soccer', category: 'Ball Sports' },
  { value: 'Baseball', label: 'Baseball', category: 'Ball Sports' },
  { value: 'Softball', label: 'Softball', category: 'Ball Sports' },
  { value: 'Volleyball', label: 'Volleyball', category: 'Ball Sports' },
  { value: 'Beach Volleyball', label: 'Beach Volleyball', category: 'Ball Sports' },
  
  // Racquet Sports
  { value: 'Tennis', label: 'Tennis', category: 'Racquet Sports' },
  { value: 'Badminton', label: 'Badminton', category: 'Racquet Sports' },
  { value: 'Squash', label: 'Squash', category: 'Racquet Sports' },
  { value: 'Racquetball', label: 'Racquetball', category: 'Racquet Sports' },
  { value: 'Table Tennis', label: 'Table Tennis', category: 'Racquet Sports' },
  
  // Track & Field
  { value: 'Track & Field', label: 'Track & Field', category: 'Track & Field' },
  { value: 'Cross Country', label: 'Cross Country', category: 'Track & Field' },
  { value: 'Marathon', label: 'Marathon', category: 'Track & Field' },
  
  // Water Sports
  { value: 'Swimming', label: 'Swimming', category: 'Water Sports' },
  { value: 'Diving', label: 'Diving', category: 'Water Sports' },
  { value: 'Water Polo', label: 'Water Polo', category: 'Water Sports' },
  { value: 'Rowing', label: 'Rowing', category: 'Water Sports' },
  { value: 'Crew', label: 'Crew', category: 'Water Sports' },
  { value: 'Sailing', label: 'Sailing', category: 'Water Sports' },
  { value: 'Surfing', label: 'Surfing', category: 'Water Sports' },
  { value: 'Synchronized Swimming', label: 'Synchronized Swimming', category: 'Water Sports' },
  
  // Winter Sports
  { value: 'Ice Hockey', label: 'Ice Hockey', category: 'Winter Sports' },
  { value: 'Figure Skating', label: 'Figure Skating', category: 'Winter Sports' },
  { value: 'Speed Skating', label: 'Speed Skating', category: 'Winter Sports' },
  { value: 'Skiing', label: 'Skiing', category: 'Winter Sports' },
  { value: 'Snowboarding', label: 'Snowboarding', category: 'Winter Sports' },
  { value: 'Curling', label: 'Curling', category: 'Winter Sports' },
  { value: 'Bobsled', label: 'Bobsled', category: 'Winter Sports' },
  { value: 'Luge', label: 'Luge', category: 'Winter Sports' },
  
  // Combat Sports
  { value: 'Wrestling', label: 'Wrestling', category: 'Combat Sports' },
  { value: 'Boxing', label: 'Boxing', category: 'Combat Sports' },
  { value: 'Martial Arts', label: 'Martial Arts', category: 'Combat Sports' },
  { value: 'Judo', label: 'Judo', category: 'Combat Sports' },
  { value: 'Karate', label: 'Karate', category: 'Combat Sports' },
  { value: 'Taekwondo', label: 'Taekwondo', category: 'Combat Sports' },
  { value: 'Fencing', label: 'Fencing', category: 'Combat Sports' },
  { value: 'MMA', label: 'Mixed Martial Arts (MMA)', category: 'Combat Sports' },
  
  // Gymnastics
  { value: 'Gymnastics', label: 'Gymnastics', category: 'Gymnastics' },
  { value: 'Rhythmic Gymnastics', label: 'Rhythmic Gymnastics', category: 'Gymnastics' },
  { value: 'Trampoline', label: 'Trampoline', category: 'Gymnastics' },
  { value: 'Cheerleading', label: 'Cheerleading', category: 'Gymnastics' },
  { value: 'Dance', label: 'Dance', category: 'Gymnastics' },
  
  // Target Sports
  { value: 'Archery', label: 'Archery', category: 'Target Sports' },
  { value: 'Shooting', label: 'Shooting', category: 'Target Sports' },
  { value: 'Rifle', label: 'Rifle', category: 'Target Sports' },
  { value: 'Pistol', label: 'Pistol', category: 'Target Sports' },
  
  // Other Team Sports
  { value: 'Lacrosse', label: 'Lacrosse', category: 'Team Sports' },
  { value: 'Field Hockey', label: 'Field Hockey', category: 'Team Sports' },
  { value: 'Rugby', label: 'Rugby', category: 'Team Sports' },
  { value: 'Ultimate Frisbee', label: 'Ultimate Frisbee', category: 'Team Sports' },
  
  // Individual Sports
  { value: 'Golf', label: 'Golf', category: 'Individual Sports' },
  { value: 'Bowling', label: 'Bowling', category: 'Individual Sports' },
  { value: 'Cycling', label: 'Cycling', category: 'Individual Sports' },
  { value: 'BMX', label: 'BMX', category: 'Individual Sports' },
  { value: 'Mountain Biking', label: 'Mountain Biking', category: 'Individual Sports' },
  { value: 'Triathlon', label: 'Triathlon', category: 'Individual Sports' },
  { value: 'Decathlon', label: 'Decathlon', category: 'Individual Sports' },
  { value: 'Pentathlon', label: 'Pentathlon', category: 'Individual Sports' },
  
  // Equestrian
  { value: 'Equestrian', label: 'Equestrian', category: 'Equestrian' },
  { value: 'Polo', label: 'Polo', category: 'Equestrian' },
  
  // Strength Sports
  { value: 'Weightlifting', label: 'Weightlifting', category: 'Strength Sports' },
  { value: 'Powerlifting', label: 'Powerlifting', category: 'Strength Sports' },
  { value: 'Bodybuilding', label: 'Bodybuilding', category: 'Strength Sports' },
  
  // Extreme Sports
  { value: 'Skateboarding', label: 'Skateboarding', category: 'Extreme Sports' },
  { value: 'Rock Climbing', label: 'Rock Climbing', category: 'Extreme Sports' },
  { value: 'Parkour', label: 'Parkour', category: 'Extreme Sports' },
];

// Sport-specific positions
export const SPORT_POSITIONS = {
  'Basketball': [
    'Point Guard',
    'Shooting Guard',
    'Small Forward',
    'Power Forward',
    'Center'
  ],
  'Football': [
    'Quarterback',
    'Running Back',
    'Wide Receiver',
    'Tight End',
    'Offensive Line',
    'Defensive Line',
    'Linebacker',
    'Cornerback',
    'Safety',
    'Kicker',
    'Punter'
  ],
  'Soccer': [
    'Goalkeeper',
    'Defender',
    'Midfielder',
    'Forward',
    'Striker',
    'Winger'
  ],
  'Baseball': [
    'Pitcher',
    'Catcher',
    'First Base',
    'Second Base',
    'Third Base',
    'Shortstop',
    'Left Field',
    'Center Field',
    'Right Field',
    'Designated Hitter'
  ],
  'Softball': [
    'Pitcher',
    'Catcher',
    'First Base',
    'Second Base',
    'Third Base',
    'Shortstop',
    'Left Field',
    'Center Field',
    'Right Field',
    'Designated Player'
  ],
  'Volleyball': [
    'Setter',
    'Outside Hitter',
    'Middle Blocker',
    'Opposite Hitter',
    'Libero',
    'Defensive Specialist'
  ],
  'Beach Volleyball': [
    'Blocker',
    'Defender'
  ],
  'Ice Hockey': [
    'Center',
    'Left Wing',
    'Right Wing',
    'Defenseman',
    'Goalie'
  ],
  'Lacrosse': [
    'Attack',
    'Midfield',
    'Defense',
    'Goalie'
  ],
  'Field Hockey': [
    'Forward',
    'Midfielder',
    'Defender',
    'Goalkeeper'
  ],
  'Water Polo': [
    'Center',
    'Driver',
    'Point',
    'Wing',
    'Goalkeeper'
  ],
  'Rugby': [
    'Prop',
    'Hooker',
    'Lock',
    'Flanker',
    'Number 8',
    'Scrum-half',
    'Fly-half',
    'Center',
    'Wing',
    'Fullback'
  ],
  'Wrestling': [
    'Heavyweight',
    'Light Heavyweight',
    'Middleweight',
    'Welterweight',
    'Lightweight'
  ],
  'Track & Field': [
    'Sprinter',
    'Distance Runner',
    'Hurdler',
    'Jumper',
    'Thrower',
    'Multi-Event'
  ],
  'Swimming': [
    'Freestyle',
    'Backstroke',
    'Breaststroke',
    'Butterfly',
    'Individual Medley',
    'Distance'
  ],
  'Gymnastics': [
    'All-Around',
    'Vault Specialist',
    'Bars Specialist',
    'Beam Specialist',
    'Floor Specialist'
  ],
  'Tennis': [
    'Singles',
    'Doubles'
  ],
  'Golf': [
    'Individual'
  ],
  'Cross Country': [
    'Distance Runner'
  ],
  'Rowing': [
    'Coxswain',
    'Rower'
  ],
  'Crew': [
    'Coxswain',
    'Stroke',
    'Port',
    'Starboard'
  ],
  'Fencing': [
    'Foil',
    'Épée',
    'Sabre'
  ],
  'Cheerleading': [
    'Flyer',
    'Base',
    'Back Spot'
  ],
  'Ultimate Frisbee': [
    'Handler',
    'Cutter'
  ]
};

// Helper function to get positions for a sport
export const getPositionsForSport = (sport) => {
  return SPORT_POSITIONS[sport] || ['Athlete'];
};

// Helper function to get sports by category
export const getSportsByCategory = () => {
  const grouped = {};
  SPORTS_LIST.forEach(sport => {
    if (!grouped[sport.category]) {
      grouped[sport.category] = [];
    }
    grouped[sport.category].push(sport);
  });
  return grouped;
};

// Helper function to search sports
export const searchSports = (query) => {
  const lowerQuery = query.toLowerCase();
  return SPORTS_LIST.filter(sport => 
    sport.label.toLowerCase().includes(lowerQuery) ||
    sport.category.toLowerCase().includes(lowerQuery)
  );
};